define('core/id-headers',["exports"], function (exports) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.run = run;
  // Module core/id-headers
  // All headings are expected to have an ID, unless their immediate container has one.
  // This is currently in core though it comes from a W3C rule. It may move in the future.

  const name = exports.name = "core/id-headers";

  function run() {
    document.querySelectorAll("h2:not([id]), h3:not([id]), h4:not([id]), h5:not([id]), h6:not([id])").forEach(elem => {
      $(elem).makeID();
    });
  }
});
//# sourceMappingURL=id-headers.js.map;
